<template>
  <div :id="section.id"
       class="pdf-preview-section-header">
    <div class="header">
      <div class="section-header">
        <div class="section-no">{{ section.order_no.toString().padStart(2, '0') }}</div>
        <div class="section-name">{{ section.name }}</div>
        <div class="section-no">{{ section.order_no.toString().padStart(2, '0') }}</div>
      </div>
      <div class="item-no-header">
        <div class="item-no left">Item</div>
        <div class="item-no right">Item</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    section: Object,
  }
}
</script>